export { default as PartsDiagramLoader } from './list-skeleton-loader/parts-diagram-list-loader';
